{
	"releaseVersion": "Release 24.4",
	"headers": [
		"General",
		"Gamification",
		"QA",
		"Dashboards",
		"Wallboards"
	],
	"displayHeaders": [
		"General",
		"Gamification",
		"QA",
		"Dashboards",
		"Wallboards"
	],
	"Notes": {
        "General": [
            "Hierarchy Export",
            "Subscription enhancements",
            "End Of Life Legacy Modal Widget Settings – Replaced with Slide Out Settings"
        ],
		"Messaging": [
			
		],
        "Gamification": [
            "New challenge type: Battle boats"
        ],
        "Coaching": [
            "Add columns to the coaching admin report page",
            "Add due date as optional field on coaching session",
            "Add due date as an optional field on tasks inside coaching session",
            "Send email notifications on coaching events",
            "New coaching session name column and overdue tasks filter and export option",
            "Form Page Update (Multi Select Answer Type)"
        ],
		"QA": [

		],
        "Dashboards": [
            "Widget Preset Dates Improvements: Gregorian Calendar View",
            "New Widget: My Ranking Widget",
            "Standardized Initial Widget Load",
            "Updated Publish Bar Component",
            "Hierarchy Mapping: New Columns Added",
            "Date Range Update - Rolling Year to Rolling 12 Months"
        ],
        "Wallboards": [
            "Wallboards Angular Conversion View/Slideshow"
        ]
	},
	"DirectNotes": {
		"General": [],
		"Messaging": [],
		"Gamificaton": [],
		"Coaching": [],
		"QA": [],
		"Dashboards": [],
		"Wallboards": []
	},
	"NiceInContactNotes": {
		"General": [
		],
		"Messaging": [],
		"Gamificaton": [
		],
		"Coaching": [],
		"QA": [],
		"Dashboards": [
		],
		"Wallboards": []
	},
	"Five9Notes": {
		"General": [
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	},
	"SerenovaNotes": {
		"General": [
			
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	},
	"GenesysNotes": {
		"General": [
			
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	},
	"CiscoNotes": {
		"General": [
			
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	},
	"AmazonNotes": {
		"General": [
			
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	},
	"AvayaNotes": {
		"General": [
	
		],
		"Messaging": [
		
		],
		"Gamificaton": [
		
		],
		"Coaching": [
		
		],
		"QA": [
	
		],
		"Dashboards": [

		],
		"Wallboards": [
		]
	},
	"UJetNotes": {
		"General": [
			
		],
		"Messaging": [
			
		],
		"Gamificaton": [
			
		],
		"Coaching": [
			
		],
		"QA": [
			
		],
		"Dashboards": [
			
		],
		"Wallboards": [
			
		]
	}
}